import { Link } from "react-router-dom";
import { DISCLAIMER, FOOTER_LINKS, slug } from "../../lib/site";
import { BLACK, IVORY, SLATE, SLATE_DIM, Serif } from "./kit";

export default function SiteFooter({ disclaimer = false }) {
  return (
    <footer className="relative py-14 border-t" style={{ background: BLACK, borderColor: "rgba(233,214,162,0.10)" }} data-testid="footer">
      <div className="max-w-6xl mx-auto px-6 md:px-12 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
        <div>
          <div className="text-lg tracking-[-0.01em]" style={{ ...Serif, color: IVORY }}>Maven Skies</div>
          <div className="mt-2 text-[10.5px] tracking-[0.28em] uppercase" style={{ color: SLATE_DIM }}>Building people · Building capital · Building the future</div>
        </div>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
          {FOOTER_LINKS.map((l) => (
            <Link key={l.label} to={l.href} className="text-[10.5px] tracking-[0.28em] uppercase hover:text-white transition" style={{ color: SLATE }} data-testid={`footer-${slug(l.label)}`}>
              {l.label}
            </Link>
          ))}
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-6 md:px-12 mt-10 pt-6" style={{ borderTop: "1px solid rgba(233,214,162,0.06)" }}>
        <span className="text-[10.5px] tracking-[0.28em] uppercase" style={{ color: SLATE_DIM }} data-testid="footer-line">
          Maven Skies Inc. · Regina, Saskatchewan · 2026
        </span>
        {disclaimer && (
          <p className="mt-6 max-w-3xl text-[12px] leading-[1.7]" style={{ color: SLATE_DIM }} data-testid="footer-disclaimer">{DISCLAIMER}</p>
        )}
      </div>
    </footer>
  );
}
